(() => {
  const rootPath = () => window.Shopify?.routes?.root || '/';
  const closePicker = (picker) => {
    if (!picker) return;
    const toggle = picker.querySelector('[data-swc-quantity-toggle]');
    const menu = picker.querySelector('[data-swc-quantity-menu]');
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
    if (menu) menu.hidden = true;
  };
  const closeAll = (except) => {
    document.querySelectorAll('[data-swc-quantity-picker]').forEach((picker) => {
      if (picker !== except) closePicker(picker);
    });
  };

  const giveCartFeedback = () => {
    const headerCart = document.querySelector('.site-header-cart');
    if (headerCart) {
      headerCart.classList.remove('swc-cart-feedback');
      void headerCart.offsetWidth;
      headerCart.classList.add('swc-cart-feedback');
      window.setTimeout(() => headerCart.classList.remove('swc-cart-feedback'), 600);
    }
    if (typeof navigator.vibrate === 'function') navigator.vibrate(24);
  };

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-swc-quantity-toggle]');
    if (toggle) {
      const picker = toggle.closest('[data-swc-quantity-picker]');
      const menu = picker?.querySelector('[data-swc-quantity-menu]');
      if (!picker || !menu) return;
      const open = menu.hidden;
      closeAll(picker);
      menu.hidden = !open;
      toggle.setAttribute('aria-expanded', String(open));
      return;
    }

    const option = event.target.closest('[data-swc-quantity-option]');
    if (option) {
      const picker = option.closest('[data-swc-quantity-picker]');
      const form = option.closest('[data-swc-cart-form]');
      const value = option.dataset.swcQuantityOption;
      const hidden = form?.querySelector('[data-swc-quantity]');
      const label = picker?.querySelector('[data-swc-quantity-label]');
      const custom = picker?.querySelector('[data-swc-quantity-input]');
      const toggleButton = picker?.querySelector('[data-swc-quantity-toggle]');
      if (hidden) hidden.value = value;
      if (label) label.textContent = value;
      if (custom) custom.hidden = true;
      if (toggleButton) toggleButton.hidden = false;
      closePicker(picker);
      return;
    }

    const other = event.target.closest('[data-swc-quantity-other]');
    if (other) {
      const picker = other.closest('[data-swc-quantity-picker]');
      const form = other.closest('[data-swc-cart-form]');
      const custom = picker?.querySelector('[data-swc-quantity-input]');
      const toggleButton = picker?.querySelector('[data-swc-quantity-toggle]');
      const hidden = form?.querySelector('[data-swc-quantity]');
      closePicker(picker);
      if (toggleButton) toggleButton.hidden = true;
      if (custom) {
        custom.hidden = false;
        custom.value = hidden?.value || '1';
        window.requestAnimationFrame(() => {
          custom.focus({ preventScroll: true });
          custom.select();
        });
      }
      return;
    }

    if (!event.target.closest('[data-swc-quantity-picker]')) closeAll();
  });

  document.addEventListener('input', (event) => {
    const input = event.target.closest('[data-swc-quantity-input]');
    if (!input) return;
    const hidden = input.closest('[data-swc-cart-form]')?.querySelector('[data-swc-quantity]');
    const value = Math.max(1, Number.parseInt(input.value || '1', 10) || 1);
    if (hidden) hidden.value = String(value);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const picker = event.target.closest('[data-swc-quantity-picker]');
    if (!picker) return;
    closePicker(picker);
    picker.querySelector('[data-swc-quantity-toggle]')?.focus();
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-swc-cart-form]');
    if (!form) return;
    event.preventDefault();
    const button = form.querySelector('[data-swc-atc]');
    const icon = form.querySelector('[data-swc-atc-icon]');
    const check = form.querySelector('[data-swc-atc-check]');
    const status = form.querySelector('[data-swc-status]');
    if (!button || button.getAttribute('aria-busy') === 'true') return;
    button.setAttribute('aria-busy', 'true');
    if (status) status.textContent = '';

    try {
      const response = await fetch(rootPath() + 'cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form),
      });
      if (!response.ok) throw new Error('cart_add_failed');
      await response.json();

      const cartResponse = await fetch(rootPath() + 'cart.js', { headers: { Accept: 'application/json' } });
      if (cartResponse.ok) {
        const cart = await cartResponse.json();
        document.querySelectorAll('[data-header-cart-count]').forEach((count) => {
          count.textContent = cart.item_count > 0 ? String(cart.item_count) : '';
          count.classList.toggle('visible', cart.item_count > 0);
        });
      }

      if (icon) icon.hidden = true;
      if (check) check.hidden = false;
      if (status) status.textContent = form.dataset.successText || '';
      giveCartFeedback();
      window.setTimeout(() => {
        if (icon) icon.hidden = false;
        if (check) check.hidden = true;
        if (status) status.textContent = '';
      }, 1800);
    } catch (error) {
      button.classList.add('swc__atc--error');
      window.setTimeout(() => button.classList.remove('swc__atc--error'), 350);
    } finally {
      button.removeAttribute('aria-busy');
    }
  });
})();